import React,{useContext,useEffect, useState, useRef, useMemo} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest ,deleteRequest} from '../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon,EditRowIcon,DeleteIcon, EditIcon, PaperClipIcon, ActivateIcon, DeactivateIcon, CollapseTreeIcon, ExpandTreeIcon, BranchTreeIcon} from "../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { InfinitySpin } from 'react-loader-spinner';
import AuthContext from '../../components/AuthContext';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import { DateTime } from "luxon";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css';
import UtilContext from '../../components/UtilContext';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import ReactDOMServer from 'react-dom/server';
import { MultiSelect } from 'primereact/multiselect';
import { createArrayNavigateHandlers } from '../../utils/arrayNavigate';
import { createAsyncNavigateHandlers } from '../../utils/asyncArrayNavigate';
import { showDeactivatedInLists, showInactiveEmployeesInLists } from '../../utils/moduleSettings';
import { resetTabulatorMask } from '../../utils/tabulatorResetMask';
import { normalizeForMatch } from '../../utils/textNormalize';
import { primeMultiSelectHeaderFilter } from '../../utils/primeMultiSelectHeaderFilter';
import { useTrainingCompanies } from '../../utils/useTrainingCompanies';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import { LocaleContext } from '../../components/LocaleContext';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../utils/printChrome';
import { Avatar } from 'primereact/avatar';
import { TABULATOR_AUDIT_MIN_ROW_HEIGHT } from '../../utils/tabulatorAuditColumns';
import { tabulatorDateUserColumnMinWidth } from '../../utils/tabulatorColumnMinWidth';
import {
    emitTrainingRecordListInvalidatingWrite,
    trainingCardEmployeeRowFromResponse,
} from '../../utils/trainingRecordListSync';

/**
 * trng013 (TrainingRecordDetail)
 * TREE_PARENT=TrainingCard (training group row)
 * TREE_CHILD=TrainingRecord (_children / training_card_id > 0)
 * TRNG013_FILTER_SCOPE=LOCAL_BOUNDED_DETAIL (header filters on by_employee tree only)
 */

export default function TrainingRecordDetail({ employee, type, navigationContext }) {

    const [state,dispatch] = useContext(DatabaseContext);
    const { trainingCompanies, loading: loadingCompanies } = useTrainingCompanies({ includeExcluded: true });
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,getDateFormat, formatDate, getUserColor, getUserInitials, openChosenNotificationPreferences} = useContext(UtilContext);
    const { t } = useContext(LocaleContext);
    const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
    const dateTimeFmt = `${dateFmt} HH:mm`;
    const {user} = useContext(AuthContext);

    const [closeTab,setCloseTab] = useState(false);
    const ref = useRef(null);
    const submitRef = useRef(null);
    const overlayRef = useRef(null);

    const [markUnmark, setMarkUnmarked] = useState(true);
    const [lecturers, setLecturers] = useState([]);
    const [companyContacts, setCompanyContacts] = useState([]);
    const [companyContactsList, setCompanyContactsList] = useState([]);
    const [trainingTypesList, setTrainingTypesList] = useState([]);
    const [lecturersFallback, setLecturersFallback] = useState([]);
    const [machines, setMachines] = useState(state.machines || []);
    const [selectedRecord,setSelectedRecord] = useState(null);
    const [loadingDetailData, setLoadingDetailData] = useState(true);
    const effectiveLecturers = (state.lecturers || []).length ? (state.lecturers || []) : lecturersFallback;

    useEffect(() => {
        setLoadingDetailData(true);
        const hasLecturers = (state.lecturers || []).length > 0;
        Promise.all([
            getRequest("/api/training_types?minimal=1").then((r) => (r?.data ?? r) || []),
            getRequest("/api/company_contacts?minimal=1&module=training").then((r) => {
                const list = r?.data ?? r ?? [];
                return Array.isArray(list) ? list : [];
            }),
            hasLecturers ? Promise.resolve(null) : getRequest("/api/lecturers").then((r) => (r?.data ?? r) || []),
        ])
            .then(([types, contacts, lecturersData]) => {
                setTrainingTypesList(types || []);
                setCompanyContactsList(contacts || []);
                if (!hasLecturers && Array.isArray(lecturersData)) setLecturersFallback(lecturersData);
            })
            .catch(() => {})
            .finally(() => setLoadingDetailData(false));
    }, []);

    const [columnsVisible, setColumnsVisible] = useState({'training.department.name':true,custom_training_name:true,custom_last_training_date:true,custom_next_training_date:true,
        custom_state:true,custom_training_status:true,custom_deactivation_date:true,description:true,protocol:true, custom_company_name:true,custom_machine_name:true,custom_lecturer_name:true,custom_company_contact_name:true,
        custom_record_created_at:true,custom_record_updated_at:true,
    });
    const [maskVisible, setMaskVisible] = useState(false);
const [formEmployee, setFormEmployee] = useState(employee);
    const [formType, setFormType] = useState(type);
    const [loadingEmployeeData, setLoadingEmployeeData] = useState(!!employee?.id);

    const reloadCurrentEmployee = () => {
        const id = formEmployee?.id ?? employee?.id;
        if (!id) return;
        setLoadingEmployeeData(true);
        getRequest(`/api/training_cards/by_employee/${id}`)
            .then((r) => {
                const data = trainingCardEmployeeRowFromResponse(r) ?? r?.data ?? r;
                if (data) setFormEmployee(data);
            })
            .catch(() => {})
            .finally(() => setLoadingEmployeeData(false));
    };

    const syncEmployeeToRecordList = (employeeId) => {
        if (!employeeId) return Promise.resolve();
        return getRequest(`/api/training_cards/by_employee/${employeeId}`)
            .then((r) => {
                const row = trainingCardEmployeeRowFromResponse(r);
                if (row) setFormEmployee(row);
                emitTrainingRecordListInvalidatingWrite({
                    operation: 'update',
                    id: employeeId,
                    row,
                });
            })
            .catch(() => {
                emitTrainingRecordListInvalidatingWrite({ operation: 'update', id: employeeId });
            });
    };

    // Načítanie plných dát zamestnanca (s training_card) pri otvorení
    useEffect(() => {
        if (!employee?.id) {
            setLoadingEmployeeData(false);
            return;
        }
        getRequest(`/api/training_cards/by_employee/${employee.id}`)
            .then((resp) => {
                const data = resp?.data ?? resp;
                if (data) setFormEmployee(data);
            })
            .catch(() => {})
            .finally(() => setLoadingEmployeeData(false));
    }, [employee?.id]);

    useEffect(() => {
        if (loadingEmployeeData) {
            const t = ref.current;
            if (t?.initialized) t.alert?.(t('Common.LoadingEllipsis'));
        } else {
            ref.current?.clearAlert?.();
        }
    }, [loadingEmployeeData]);

    //TODO dorobit contractor id
    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit training"))?false:true);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);


    const [visibleRecord,setVisibleRecord] = useState(false);
    const [visibleFiles,setVisibleFiles] = useState(false);
    const [images,setImages] = useState('');
    const [updatefileList, setUpdateFileList] = useState([]);
    const updateFileListRef = useRef(null);
    const [viewedImage,setViewedImage] = useState('');

    const handleUpdateFileChange = (event) => {
        setUpdateFileList(event.target.files);
    };

    const onSelectRow = (data, rows) => {
        setDeleteIcon(true);
        setEditIcon(true);
        formikUpdate.resetForm();
        if(data.length>0){
            let children = 0;
            let parent = 0;
            data.forEach(obj => {
                if(obj?.training_card_id>0){
                    children++;
                }
                else parent++;
            });
            if(children>0 && parent==0){
                if(user.permissions?.includes("delete training"))setDeleteIcon(false);
                if(data?.length==1 && user.permissions?.includes("edit training")){
                    setSelectedRecord(data[0]);
                    console.log(rows[0].getTreeParent().getData()?.training_id);
                    formikUpdate.setFieldValue("id",data[0]?.id);
                    //formikUpdate.setFieldValue("training_id",state.training_employees.filter(card => card.id==data[0]?.training_card_id)[0]?.training_id);
                    formikUpdate.setFieldValue("training_id",rows[0].getTreeParent().getData()?.training_id);
                    formikUpdate.setFieldValue("last_training_date",data[0]?.last_training_date);
                    formikUpdate.setFieldValue("description",data[0]?.description);
                    formikUpdate.setFieldValue("company_id",data[0]?.company_id);
                    formikUpdate.setFieldValue("machines",data[0]?.machines.map((machine) => ({name:machine.name,id:machine.id})));
                    formikUpdate.setFieldValue("lecturer_id",data[0]?.company_contact?.lecturer_id);
                    formikUpdate.setFieldValue("company_contact_id",data[0]?.company_contact?.id);
                    const list = companyContactsList || [];
                    const my_machines = [];
                    list.filter(contact => contact.company_id == data[0]?.company_id)?.forEach(contact => {
                        (contact?.machines || []).forEach(machine => my_machines.push(machine.id));
                    });
                    setMachines((state.machines || []).filter(machine => my_machines.includes(machine.id)));
                    const my_contacts = list.filter(contact => contact.company_id == data[0]?.company_id && (contact.machines || []).filter(machine => (data[0]?.machines || []).map(mach => mach.id).includes(machine.id))?.length > 0)?.map(contact => contact.lecturer_id);
                    setLecturers((state.lecturers || []).filter(lecturer => my_contacts?.includes(lecturer.id)));
                    setCompanyContacts(list.filter(contact => contact.company_id == data[0]?.company_id && (contact.machines || []).filter(machine => (data[0]?.machines || []).map(mach => mach.id).includes(machine.id))?.length > 0 && contact.lecturer_id == data[0]?.company_contact?.lecturer_id));
                    setEditIcon(false);
                }
            }
        }
    };

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    function changeCompany(company_id){
        const list = companyContactsList || [];
        const machineIds = [];
        list.filter(contact => contact.company_id == company_id)?.forEach(contact => {
            (contact?.machines || []).forEach(machine => machineIds.push(machine.id));
        });
        setMachines((state.machines || []).filter(machine => machineIds.includes(machine.id)));
        formikUpdate.setFieldValue('company_id',company_id);
        formikUpdate.setFieldValue('machines',[]);
        formikUpdate.setFieldValue('lecturer_id','');
        formikUpdate.setFieldValue('company_contact_id','');
        formikUpdate.setFieldValue("employees",[]);
    }

    function changeMachine(machines){
        const list = companyContactsList || [];
        const machines_ids = machines?.map(mach => mach.id) || [];
        const contacts = list.filter(contact => contact.company_id == formikUpdate.values?.company_id && machines_ids.every(id => contact.machines?.map(mch => mch.id).includes(id)))?.map(contact => contact.lecturer_id);
        setLecturers(effectiveLecturers.filter(lecturer => contacts?.includes(lecturer.id)));
        formikUpdate.setFieldValue("machines",machines);
        formikUpdate.setFieldValue('lecturer_id','');
        formikUpdate.setFieldValue('company_contact_id','');
        formikUpdate.setFieldValue("employees",[]);
    }
        
    function changeLecturer(lecturer_id){
        const list = companyContactsList || [];
        const machineIds = formikUpdate.values?.machines?.map(m => m.id) || [];
        setCompanyContacts(list.filter(contact => contact.company_id == formikUpdate.values?.company_id && machineIds.every(id => contact.machines?.map(mch => mch.id).includes(id)) && contact.lecturer_id == lecturer_id));
        formikUpdate.setFieldValue('lecturer_id',lecturer_id);
        formikUpdate.setFieldValue('company_contact_id','');
        formikUpdate.setFieldValue("employees",[]); 
    }

    function getRecordFiles(id){
        getRequest(`/api/training_records/protocols/${id}`).then((response) => {
            console.log(response);
            if(response.data!=="{}")setImages(response.data);
        });
    }

    useEffect(() => {
            // Update the document title using the browser API
        if(selectedRecord!=null){
            console.log(selectedRecord);
            console.log(formikUpdate.values);
            //getRecordFiles(selectedRecord.id);
        }
    },[selectedRecord]);

    const formikUpdate = useFormik({
        initialValues: selectedRecord ? 
            {id: selectedRecord?.id, training_id: selectedRecord?.training_id,
            last_training_date:selectedRecord?.last_training_date,description:selectedRecord?.description,
            company_id:selectedRecord?.company_id,machines:selectedRecord?.machines.map((machine) => ({name:machine.name,id:machine.id})),
            lecturer_id:selectedRecord?.company_contact?.lecturer_id,company_contact_id:selectedRecord?.company_contact_id} : 
            {training_id: '',last_training_date: '',description:'',company_id:'',machines:[],lecturer_id:'',company_contact_id:''},
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                if(value=="machines"){
                    formData.append("machines", values.machines.map(machine => machine.id));
                }
                else formData.append(value, values[value] != null ? values[value] : "");
            }
            for(let i = 0;i<updatefileList.length;i++){
                //console.log("IMAGE :"+fileList[i].name);
                formData.append('files[]',updatefileList[i]);
            }
            postRequest(`/api/training_records/update/${formikUpdate.values.id}`, formData,true)
            .then((response) => {
                setVisibleRecord(false);
                formikUpdate.resetForm();
                if(updatefileList.length){
                    setUpdateFileList([]);
                    updateFileListRef.current.value = null;
                }
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                if (formEmployee?.id) syncEmployeeToRecordList(formEmployee.id);
            }).catch((reason) => {
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    alert(t('Common.Toast.ActionFailedDetail'));
                }
            });
        },
    });

    function hideEditRecord(){
        formikUpdate.resetForm();
        setVisibleRecord(false);
    }

    const showDeactivated = showDeactivatedInLists(state.module_settings, 'training');
    const showInactiveEmployees = showInactiveEmployeesInLists(state.module_settings);
    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(() => {
        const buildFetchRecord = (toParams = () => '') => async (direction, currentId) => {
            setDialogText?.(t('Common.Loading'));
            setVisible?.(true);
            try {
                const q = toParams();
                const show = showDeactivated ? '1' : '0';
                const showInactive = showInactiveEmployees ? '1' : '0';
                const url = `/api/training_cards/navigate?direction=${direction}${currentId ? '&id=' + currentId : ''}&show_deactivated=${show}&show_inactive_employees=${showInactive}${q ? '&' + q : ''}`;
                const resp = await getRequest(url);
                return resp?.data ?? null;
            } finally {
                setVisible?.(false);
            }
        };
        if (navigationContext?.filters != null || navigationContext?.sorters != null) {
            const toParams = () => {
                const p = new URLSearchParams();
                (navigationContext.filters || []).forEach(f => {
                    if (f.value != null && String(f.value).trim() !== '') p.set(`filter_${f.field}`, f.value);
                });
                if (navigationContext.sorters?.length) p.set('sorters', JSON.stringify(navigationContext.sorters));
                return p.toString();
            };
            return createAsyncNavigateHandlers(buildFetchRecord(toParams), setFormEmployee, () => formEmployee?.id);
        }
        return createAsyncNavigateHandlers(buildFetchRecord(), setFormEmployee, () => formEmployee?.id);
    }, [navigationContext, formEmployee?.id, showDeactivated, showInactiveEmployees, setDialogText, setVisible]);

    function TrainingName(props) {
        const rowData = props.cell.getRow().getData();
        var parent = props.cell.getRow()?.getTreeParent();
        if(rowData?._children) return <div className='training_name'>{rowData.training.name}</div>;
        if(parent){
            let parent_array = parent._row.data._children;
            for(let i = 0;i<parent_array.length;i++){
                if(parent_array[i].id == rowData.id){
                    if(i==parent_array.length-1)return <div className='training_name'>Prvotné školenie</div>;
                    else return <div className='training_name'>{parent_array.length-1-i}. Opakované školenie</div>;
                }
            }
            return <div className='training_name'>{parent._row.data.training.name}</div>;
        }
        return <span className='text-red-500'>{t('TrainingRecordDetail.Text.Neskoleny')}</span>;
    }
    
    function trainingHeaderFilter(headerValue, rowValue, rowData, filterParams) {
        console.log(rowData);
        if(rowData?._children){
            if(headerValue!=""){
                return rowData.training.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(headerValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
            }
        }
        if(headerValue!=""){
                return rowData.training.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(headerValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
        }
    }  

    function DeactivationDate(props) {
        const rowData = props.cell.getRow().getData();
        return rowData?.deactivation_date ? DateTime.fromISO(rowData.deactivation_date).toFormat(dateFmt) : t('Common.ActivePlural');
      }

      function LastTrainingDate(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?.last_training_date) return DateTime.fromISO(rowData.last_training_date).toFormat(dateFmt);
        if(rowData?._children.length > 0) return DateTime.fromISO(rowData._children[0].last_training_date).toFormat(dateFmt);
        if(new Date(rowData?.initial_date) > new Date())return <span className='text-blue-600'>{t('Common.Scheduled')}</span>;
        return <span className='text-red-500'>{t('TrainingRecordDetail.Text.Neskoleny')}</span>;
      }

      function NextTrainingDate(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?.next_training_date) return DateTime.fromISO(rowData.next_training_date).toFormat(dateFmt);
        if(rowData?._children.length > 0) return DateTime.fromISO(rowData._children[0].next_training_date).toFormat(dateFmt);
        if(new Date(rowData?.initial_date) > new Date())return <span className='text-blue-600'>{t('Common.Scheduled')}</span>;
        return <span className='text-red-500'>{t('TrainingRecordDetail.Text.Neskoleny')}</span>;
      }

    function dateHeaderFilter(headerValue, rowValue, rowData, filterParams){
        if(filterParams.name=="deactivation_date"){
            const hv = (headerValue || "").trim();
            if (!hv) return true;
            const isActive = !rowData?.deactivation_date || rowData?.deactivation_date === "";
            const activeMatch = "aktívne".includes(hv.toLowerCase()) || hv.toLowerCase().includes("aktívne");
            if (activeMatch && isActive) return true;
            if (isActive) return false;
            return DateTime.fromISO(rowData.deactivation_date).toFormat(dateFmt).includes(hv);
        }
        if(rowData?._children?.length==0){
            if(headerValue!=""){
                if(new Date(rowData?.initial_date) > new Date())return t('Common.Scheduled').toLowerCase().includes(headerValue.toLowerCase());
                return t('TrainingRecordDetail.Text.Neskoleny').toLowerCase().includes(headerValue.toLowerCase());
            }
        }
        if(filterParams.name=="last_training_date"){
            return DateTime.fromISO(rowData?._children[0]?.last_training_date).toFormat(dateFmt).includes(headerValue);
        }
        else if(filterParams.name=="next_training_date"){
            return DateTime.fromISO(rowData?._children[0]?.next_training_date).toFormat(dateFmt).includes(headerValue);
        }
    }

      function StateFormatter(props){
        const rowData = props.cell.getRow().getData();
        var parent = props.cell.getRow()?.getTreeParent();
        if(parent){
            let parent_array = parent._row.data._children;
            for(let i = 0;i<parent_array.length;i++){
                if(parent_array[i].id == rowData.id){
                    if(i==0){
                        if(parent._row.data?.deactivation_date!=null && parent._row.data?.deactivation_date!=""){
                            return "DEA";
                        }
                        else if(new Date(parent_array[i]?.next_training_date) < new Date()){
                            return "NOK";
                        }
                        else return "OK";
                    }
                    else return "OK"; 
                }
            }
        }
        if(rowData?.deactivation_date!=null && rowData?.deactivation_date!="")return "DEA";
        if(rowData?._children?.length > 0){           
            if(new Date(rowData?._children[0]?.next_training_date) < new Date()){
                return "NOK";
            }
            return "OK"
        }
        else if(new Date(rowData?.initial_date) > new Date()){
            return "OK";
        }
        else return "NOK";
      }

    const accept = () => {
        let rows_to_delete = [];
        rows_to_delete = ref.current.getSelectedData();
        const employeeId = formEmployee?.id;
        rows_to_delete.forEach(element => {
            deleteRequest(`/api/training_records/${element.id}`)
            .then((response) => {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
            }).catch((reason) => {
                alert(reason);
                toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
            });
        });
        if (employeeId) syncEmployeeToRecordList(employeeId);
    }

        const reject = () => {
            toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
        }
    
        const confirm = () => {
            confirmDialog({
                message: t('Common.ConfirmDeleteRecord'),
                header: t('Common.ConfirmDelete'),
                icon: 'pi pi-info-circle',
                acceptClassName: 'p-button-danger',
                acceptLabel: t('Common.Yes'),
                rejectLabel: t('Common.No'),
                accept,
                reject
            });
        };

    const acceptFile = (id) => {
        getRequest(`/api/training_records/deleteProtocol/${id}`)
        .then((response) => {
            toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.FileDeletedDetail') });
            getRecordFiles(selectedRecord?.id);
        }).catch((reason) => {
            alert(reason);
            toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.FileDeleteFailedDetail'), life: 3000 });
        })
    };

    function deleteFiles(img){
        confirmDialog({
            message: t('Common.ConfirmDeleteFile'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept:reject,
            reject:() => acceptFile(img.id)
        });
    }

    function stateHeaderFilter(headerValue, rowValue, rowData, filterParams){
        if (headerValue === "Všetko" || !headerValue || String(headerValue).trim() === '') return true;
        let state = "";
        if(rowData?._children?.length > 0){
            if(new Date(rowData?._children[0]?.next_training_date) < new Date()){
                state="NOK";
            }
            else state="OK"
        }
        else if(new Date(rowData?.initial_date) > new Date()){
            state="OK";
        }
        else state="NOK"
        if(rowData?.deactivation_date!=null && rowData?.deactivation_date!="")state="DEA";
        const selected = String(headerValue).split(',').map(s => s.trim().toUpperCase()).filter(Boolean);
        return selected.length > 0 && selected.includes(state.toUpperCase());
      }

    function TrainingStatusFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const isActive = !rowData?.deactivation_date || rowData?.deactivation_date === "";
        return <span className={isActive ? '' : 'text-red-600'}>{isActive ? t('Common.ActivePlural') : t('Common.Deactivated')}</span>;
    }

    function trainingStatusHeaderFilter(headerValue, rowValue, rowData, filterParams) {
        if (!headerValue || String(headerValue).trim() === '') return true;
        const isActive = !rowData?.deactivation_date || rowData?.deactivation_date === "";
        const rowStatus = isActive ? t('Common.ActivePlural') : t('Common.Deactivated');
        const selected = String(headerValue).split(',').map(s => s.trim()).filter(Boolean);
        return selected.length > 0 && selected.includes(rowStatus);
    }

    function trainingDepartmentHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue || String(headerValue).trim() === '') return true;
        const selected = String(headerValue).split(',').map(s => s.trim()).filter(Boolean);
        if (selected.length === 0) return true;
        const name = String(rowData?.training?.department?.name ?? rowValue ?? '').trim();
        if (!name) return false;
        const norm = normalizeForMatch(name);
        return selected.some(s => normalizeForMatch(s) === norm);
    }

    function deactivationDateSorter(a, b, aRow, bRow, column, dir) {
        const da = aRow?.getData?.()?.deactivation_date;
        const db = bRow?.getData?.()?.deactivation_date;
        const aEmpty = !da || da === "";
        const bEmpty = !db || db === "";
        if (aEmpty && bEmpty) return 0;
        if (aEmpty) return dir === "asc" ? -1 : 1;
        if (bEmpty) return dir === "asc" ? 1 : -1;
        const diff = new Date(da) - new Date(db);
        return dir === "asc" ? diff : -diff;
    }

    function viewFile(file_id){
        getRequest(`/api/training_records/protocol/${file_id}`).then((response) => {
            console.log(response);
            setVisibleFiles(true);
            setViewedImage(response.data);
        });
    }

    function Protocol(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?._children?.length > 0){   
            if(rowData?._children[0]?.files)return <div className='flex flex-row'>{rowData?._children[0]?.files.map((img) => (<a style={{color:'blue',cursor:'pointer',marginBottom:'2px',width: '24px',display: 'block'}} onClick={() => {viewFile(img.id);}}><PaperClipIcon/></a>))}</div>
        }
        return rowData.files ? <div className='flex flex-row'>{rowData.files.map((img) => (<a style={{color:'blue',cursor:'pointer',marginBottom:'2px',width: '24px',display: 'block'}} onClick={() => {viewFile(img.id);}}><PaperClipIcon/></a>))}</div> : null;
    }

    function CompanyName(props) {
        const rowData = props.cell.getRow().getData();
        /*if(rowData?._children?.length > 0){
            return rowData?._children[0]?.company?.name;
        }*/
        return rowData?.company?.name;
    }

    function companyHeaderFilter(headerValue, rowValue, rowData, filterParams) {
        if(headerValue!=""){
                return rowData?.company?.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(headerValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
        }
    }  

      function MachineName(props) {
        const rowData = props.cell.getRow().getData();
        /*if(rowData?._children?.length > 0){
            return rowData?._children[0]?.machines?.map(machine => machine?.name).join('/');
        }*/
        return rowData?.machines?.map(machine => machine?.name).join('/');
      }

    function machineHeaderFilter(headerValue, rowValue, rowData, filterParams) {
        if(headerValue!=""){
            return rowData?.machines?.map(machine => machine?.name).join('/').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(headerValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
        }
    }  

      function LecturerName(props) {
        const rowData = props.cell.getRow().getData();
        /*if(rowData?._children?.length > 0){
            return rowData?._children[0]?.company_contact?.lecturer?.name;
        }*/
        return rowData?.company_contact?.lecturer?.name;
      }

    function lecturerHeaderFilter(headerValue, rowValue, rowData, filterParams) {
        if(headerValue!=""){
            return rowData?.company_contact?.lecturer?.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(headerValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
        }
    }  

      function CompanyContactName(props) {
        const rowData = props.cell.getRow().getData();
        /*if(rowData?._children?.length > 0){
            if(rowData?._children[0]?.company_contact?.employee_id) return rowData?._children[0]?.company_contact?.employee?.name;
            return rowData?._children[0]?.company_contact?.name;
        }*/
        if(rowData?.company_contact?.employee_id)return rowData?.company_contact?.employee?.name;
        return rowData?.company_contact?.name;
      }

    function contactHeaderFilter(headerValue, rowValue, rowData, filterParams) {
        if(headerValue!=""){
            if(rowData?.company_contact?.employee_id)return rowData?.company_contact?.employee?.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(headerValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
            return rowData?.company_contact?.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(headerValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
        }
    }

    function isTrainingRecordChildRow(rowData) {
        if (!rowData || rowData._children) return false;
        return Number(rowData.training_card_id) > 0;
    }

    function recordAuditDateText(raw) {
        if (raw == null || raw === '') return '';
        if (formatDate) {
            const text = formatDate(raw, dateTimeFmt, true);
            return text || '';
        }
        const dt = DateTime.fromISO(String(raw));
        return dt.isValid ? dt.toFormat(dateTimeFmt) : '';
    }

    function RecordCreatedAtFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if (!isTrainingRecordChildRow(rowData)) return null;
        const u = rowData?.created_by_user;
        const displayName = u?.employee?.name || u?.username || '';
        const text = recordAuditDateText(rowData?.created_at);
        return (
            <div className="flex items-center justify-start w-full h-full min-w-0 gap-1">
                {u ? (
                    <Avatar
                        className="shrink-0"
                        title={displayName}
                        label={getUserInitials?.(displayName) || ''}
                        shape="circle"
                        style={{ backgroundColor: getUserColor?.(u?.username) || '#6b7280', color: '#ffffff' }}
                    />
                ) : null}
                <div className="min-w-0 flex-1 truncate whitespace-nowrap" title={text || undefined}>{text}</div>
            </div>
        );
    }

    function RecordUpdatedAtFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if (!isTrainingRecordChildRow(rowData)) return null;
        const u = rowData?.updated_by_user ?? rowData?.last_touched_by_user;
        const displayName = u?.employee?.name || u?.username || '';
        const text = recordAuditDateText(rowData?.updated_at);
        return (
            <div className="flex items-center justify-start w-full h-full min-w-0 gap-1">
                {u ? (
                    <Avatar
                        className="shrink-0"
                        title={displayName}
                        label={getUserInitials?.(displayName) || ''}
                        shape="circle"
                        style={{ backgroundColor: getUserColor?.(u?.username) || '#6b7280', color: '#ffffff' }}
                    />
                ) : null}
                <div className="min-w-0 flex-1 truncate whitespace-nowrap" title={text || undefined}>{text}</div>
            </div>
        );
    }

    const recordCreatedTitle = t('TrainingRecordDetail.Text.Zalozenie_zaznamu');
    const recordUpdatedTitle = t('TrainingRecordDetail.Text.Posledna_aktivita_zaznamu');

    const [columns,setColumns] = useState([
        { title: '', field: 'id',visible:false},
        {
            formatter:"rowSelection", titleFormatter:"rowSelection",titleFormatterParams:{rowRange:"active"},hozAlign:"center",width: 44,minWidth: 44,headerSort:false,resizable:false,
            cellClick: function(e, cell) {
              cell.getRow().toggleSelect();
              console.log(cell.getRow(), cell.getRow().getTreeParent());
            }
        },
        { title: t('Common.TrainingName'), field: 'custom_training_name', minWidth: 200, widthGrow: 3, headerFilter: "input", headerFilterFunc: trainingHeaderFilter, formatter: reactFormatter(<TrainingName/>) },
        { title: t('Common.TrainingDepartment'), field: 'training.department.name', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { options: (state.departments || []).map(d => ({ label: d.name, value: d.name })), placeholder: t('Common.TrainingDepartment') }, headerFilterFunc: trainingDepartmentHeaderFilter, minWidth: 280, widthGrow: 1 },
        { title: t('Common.LastTraining'), field: 'custom_last_training_date', headerFilter: "input", headerFilterFunc: dateHeaderFilter, headerFilterFuncParams: { name: "last_training_date" }, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<LastTrainingDate/>) },
        { title: t('Common.NextTraining'), field: 'custom_next_training_date', headerFilter: "input", headerFilterFunc: dateHeaderFilter, headerFilterFuncParams: { name: "next_training_date" }, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<NextTrainingDate/>) },
        { title: t('Common.Status'), field: 'custom_state', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { options: [{ label: 'OK', value: 'OK' }, { label: 'NOK', value: 'NOK' }, { label: 'DEA', value: 'DEA' }], placeholder: t('Common.Status'), minWidth: '150px' }, headerFilterFunc: stateHeaderFilter, minWidth: 150, widthGrow: 1, formatter: reactFormatter(<StateFormatter/>) },
        { title: t('Common.Deactivation'), field: 'custom_deactivation_date', headerFilter: "input", headerFilterFunc: dateHeaderFilter, headerFilterFuncParams: { name: "deactivation_date" }, sorter: deactivationDateSorter, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<DeactivationDate/>) },
        { title: t('Common.Description'), field: 'description', headerFilter: "input", minWidth: 320, widthGrow: 1 },
        { title: 'Protokol', field: 'protocol', headerFilter: "input", minWidth: 200, widthGrow: 2, formatter: reactFormatter(<Protocol/>) },
        { title: t('Common.TrainingCompanyShort'), field: 'custom_company_name', headerFilter: "input", headerFilterFunc: companyHeaderFilter, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<CompanyName/>) },
        { title: 'Stroj', field: 'custom_machine_name', headerFilter: "input", headerFilterFunc: machineHeaderFilter, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<MachineName/>) },
        { title: 'Lektor', field: 'custom_lecturer_name', headerFilter: "input", headerFilterFunc: lecturerHeaderFilter, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<LecturerName/>) },
        { title: t('Common.Trainer'), field: 'custom_company_contact_name', headerFilter: "input", headerFilterFunc: contactHeaderFilter, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<CompanyContactName/>) },
        { title: t('Common.TrainingStatus'), field: 'custom_training_status', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { options: [{ label: t('Common.ActivePlural'), value: "Aktívne" }, { label: t('Common.Deactivated'), value: "Deaktivované" }], placeholder: t('Common.TrainingStatus'), minWidth: '180px' }, headerFilterFunc: trainingStatusHeaderFilter, formatter: reactFormatter(<TrainingStatusFormatter/>), minWidth: 200, widthGrow: 1 },
        { title: recordCreatedTitle, field: 'custom_record_created_at', minWidth: tabulatorDateUserColumnMinWidth(recordCreatedTitle), formatter: reactFormatter(<RecordCreatedAtFormatter />), hozAlign: 'left' },
        { title: recordUpdatedTitle, field: 'custom_record_updated_at', minWidth: tabulatorDateUserColumnMinWidth(recordUpdatedTitle), formatter: reactFormatter(<RecordUpdatedAtFormatter />), hozAlign: 'left' },
    ]);

    useEffect(() => {
        const options = (state.departments || []).map(d => ({ label: d.name, value: d.name }));
        setColumns(prev => {
            const next = prev.map(col => col.field === 'training.department.name' ? { ...col, headerFilterParams: { options, placeholder: t('Common.TrainingDepartment') } } : col);
            if (ref.current?.setColumns) setTimeout(() => ref.current.setColumns(next), 0);
            return next;
        });
    }, [state.departments]);

    function setMask(item,value){
        const columnVisible = {...columnsVisible};
       columnVisible[item] = value;
       console.log(columnVisible);
        for(const val in columnVisible) {
          if(columnVisible[val]==false){
            ref.current.hideColumn(`${val}`);
          }
          else{
            ref.current.showColumn(`${val}`);
          }
        }
        setColumnsVisible(columnVisible);
        setTimeout(() => {
            ref.current.redraw(true);
        }, 0);
      }

      const itemRenderer = (item, options) => (
        <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
      );
    
      const [expandedKeys, setExpandedKeys] = useState({});
    
      const handleClickOutside = (event) => {
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            setExpandedKeys({});
        }
      };
    
      useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    const defaultColumnsVisible = {'training.department.name':true,custom_training_name:true,custom_last_training_date:true,custom_next_training_date:true,custom_state:true,custom_training_status:true,custom_deactivation_date:true,description:true,protocol:true,custom_company_name:true,custom_machine_name:true,custom_lecturer_name:true,custom_company_contact_name:true,custom_record_created_at:true,custom_record_updated_at:true};
    const resetMask = () => resetTabulatorMask({ page: 'TrainingRecordDetail', defaultColumnsVisible, ref, columns, setColumnsVisible });
  
      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: [
            {
                key: '0_1',
                label: t('Common.SetFilter'),
                icon: 'pi pi-filter',
                command: () => {setUserMaskFilter("TrainingRecordDetail","set_filters",null,ref.current.getHeaderFilters(),null);},
                template: itemRenderer,
            },
              {
                key: '0_2',
                label: t('Common.ClearFilter'),
                icon: 'pi pi-filter-slash',
                command: () => {setUserMaskFilter("TrainingRecordDetail","set_filters",null,[],null);ref.current.clearHeaderFilter();},
                template: itemRenderer,
            },
            {
                key: '0_3',
                label: t('Common.SetSorting'),
                icon: 'pi pi-sort-alt',
                command: () => {setUserMaskFilter("TrainingRecordDetail","set_sorters",null,null,null,ref.current.getSorters());OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_4',
                label: t('Common.ClearSorting'),
                icon: 'pi pi-sort-alt-slash',
                command: () => {setUserMaskFilter("TrainingRecordDetail","set_sorters",null,null,null,[]);ref.current.setSort([]);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_5',
                label: t('Common.SetMask'),
                icon: 'pi pi-server',
                command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_5b',
                label: t('Common.ResetUserMask'),
                icon: 'pi pi-refresh',
                command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
                template: itemRenderer,
            },
            {
              key: '0_6',
              label: t('Common.Notifications'),
              icon: 'pi pi-envelope',
              command: () => {openChosenNotificationPreferences('TrainingRecordDetail');OverflowMenuProvider.setVisible(null);},
              template: itemRenderer,
          },
        ]
      }
    ];function changeMarkings(value){
        const columnVisible = {...columnsVisible};
        for(let val in columnVisible) {
        if(columnVisible[val]!=="specific_id" || columnVisible[val]!=="editor"|| columnVisible[val]!=="end_of_validity"){
            columnVisible[val]=value;
            ref.current.hideColumn(`${val}`);
        }
        };
        setColumnsVisible(columnVisible);
        setTimeout(() => {
            ref.current.redraw(true);
        }, 0);
      }


    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <IntersectionObserverWrapper>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => {getRecordFiles(selectedRecord?.id);setVisibleRecord(true);}}><EditIcon/></button></div>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="print"><button onClick={() => ref.current.print(false, true)}><PrintIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => reloadCurrentEmployee()} title={t('Common.Refresh')}><RefreshIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled onClick={() => openFavoriteDialog(t('Util.Tab.EditGaugeCalibration'),"TrainingRecordDetail")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="price"><button className="disabled:opacity-25" disabled onClick={() => setFastView("TrainingRecordDetail",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
        </div>
        {loadingDetailData ? (
        <div className="flex flex-col items-center justify-center h-[calc(100vh-177px)] bg-gray-100 gap-4">
            <InfinitySpin width="120" color="#333" />
            <span className="text-gray-700">{t('Common.LoadingEllipsis')}</span>
        </div>
        ) : (
        <>
        <Splitter className='h-[calc(100vh_-_177px)]' layout="vertical" pt={{ gutter: { className: 'bg-[#333] h-8' },gutterHandler: { className: 'bg-secondary ' } }}>
    <SplitterPanel className="flex align-items-center justify-content-center overflow-y-auto " minSize={10} size={10}>
        <div className="w-full relative flex flex-col overflow-x">
          <div className='xl:grid grid-cols-2 gap-1 mb-2'>
          <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.SKOLENIA_ZAMESTNANCA')}</h1>
                <label className="block text-md font-semibold text-gray-800">Por.č.: {formEmployee.id}</label>
                <div className="mt-6">
                    <div className="md:grid grid-cols-2 gap-2 mb-2">
                      <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Meno zamestnanca
                        </label>
                        <input
                            name='name'
                            type="text"
                            readOnly value={formEmployee.name}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="defined_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('CustomerAdd.Label.DefinedId')}</label>
                        <input
                            name='defined_id'
                            type="number"
                            readOnly value={formEmployee.defined_id}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    </div>
                </div>  
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <div>
                    <div className="md:grid grid-cols-2 gap-2 mb-2">
                      <div>
                        <label
                            htmlFor="date_of_entry"
                            className="block text-md font-semibold text-gray-800"
                        >{t('EmployeeList.Column.DateOfEntry')}</label>
                        <input
                            name='date_of_entry'
                            type="text"
                            readonly value={formEmployee.date_of_entry ? DateTime.fromISO(formEmployee.date_of_entry).toFormat(dateFmt) : ""}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="date_of_departure"
                            className="block text-md font-semibold text-gray-800"
                        >{t('EmployeeList.Column.DateOfDeparture')}</label>
                        <input
                            name='date_of_departure'
                            type="text"
                            readonly value={formEmployee.date_of_departure ? DateTime.fromISO(formEmployee.date_of_departure).toFormat(dateFmt) : ""}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    </div>
                    <div className="md:grid grid-cols-2 gap-2 mb-2">
                        <div>
                        <label
                            htmlFor="department_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Department')}</label>
                        <select 
                        name='department_id'
                        disabled value={formEmployee.department_id}
                        className='block w-full h-[42px] px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                          <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                          {(state.departments || []).map((department) => (
                            <option key={department.id} value={department.id}>{department.name}</option>
                          ))}
                        </select>
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('EmployeeAdd.Label.Description')}</label>
                        <input
                            name='description'
                            type="text"
                            readOnly value={formEmployee.description}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    </div>
                </div>  
            </div>
            </div> 
            </div>
             </SplitterPanel>
    <SplitterPanel className="flex flex-col align-items-center justify-content-center w-full overflow-y-auto" size={40} style={{minHeight: '110px'}}>
    <ReactTabulator
      data={(formEmployee?.training_card) ?? []} 
      onRef={(r) => (ref.current = r.current)}
      className='h-full w-full' //176px h-[calc(100vh_-_176px)]
      columns={columns}
      events={{
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
            if (loadingEmployeeData) ref.current?.alert?.(t('Common.LoadingEllipsis'));
            let mask = state.user_mask_filters.filter(mask => mask.page=="TrainingRecordDetail");
            const safeParse = (v, fallback) => {
                if (v === null || v === undefined) return fallback;
                if (typeof v === "string") {
                try { return JSON.parse(v); } catch { return fallback; }
                }
                return v; // už je array/object
            };
            if (mask.length > 0) {
                const attributes  = safeParse(mask[0].attributes, []);
                const filters     = safeParse(mask[0].filters, []);
                const sorters     = safeParse(mask[0].sorters, []);
                const json_columns = safeParse(mask[0].columns, {});
                if (Array.isArray(attributes) && attributes.length > 1) {
                    ref.current.setColumnLayout(attributes);
                }
                if (Array.isArray(filters)) {
                    filters.forEach(f => ref.current.setHeaderFilterValue(f.field, f.value));
                }
                if (Array.isArray(sorters) && sorters.length > 0) {
                    ref.current.setSort(sorters);
                }
                if (json_columns && typeof json_columns === "object") {
                    setColumnsVisible(json_columns);
                    for (let column in json_columns) {
                        if (json_columns[column] === false) ref.current.hideColumn(column);
                        else ref.current.showColumn(column);
                    }
                }
            }
          },
          columnMoved: () => { setUserMaskFilter("TrainingRecordDetail", "column_move", null, null, ref.current.getColumnLayout()); },
          columnResized: () => { setUserMaskFilter("TrainingRecordDetail", "column_resized", null, null, ref.current.getColumnLayout()); },
      }}
        options={{renderHorizontal:"virtual",rowHeight:TABULATOR_AUDIT_MIN_ROW_HEIGHT,movableColumns:true,resizableColumnFit:true,
        dataTree:true,dataTreeStartExpanded:false,dataTreeFilter:false,dataTreeElementColumn: "custom_training_name",
        dataTreeCollapseElement:ReactDOMServer.renderToStaticMarkup(<CollapseTreeIcon/>),
        dataTreeExpandElement:ReactDOMServer.renderToStaticMarkup(<ExpandTreeIcon/>),
        dataTreeBranchElement:ReactDOMServer.renderToStaticMarkup(<BranchTreeIcon/>),
        printAsHtml:true,printRowRange:"active",printCopyStyle:true,
        /*groupBy:"training.department.name",
        groupHeader:function(value, count, data, group){
            //value - the value all members of this group share
            //count - the number of rows in this group
            //data - an array of all the row data objects in this group
            //group - the group component for the group
            if(value=="----------")return "Všeobecné <span style='color:#666; margin-left:10px;'>(" + count + ")</span>";
            return value + "<span style='color:#666; margin-left:10px;'>(" + count + ")</span>";
        },*/
        printHeader:function(){
            const bodyHtml = ReactDOMServer.renderToStaticMarkup(<div>
              <div className="mt-6">
                  <div className="md:grid grid-cols-2 gap-1 mb-2">
                    <div className='mb-2'>
                      <label
                          htmlFor="name"
                          className="block text-left text-lg font-semibold text-gray-800"
                      >
                          Meno zamestnanca
                      </label>
                      <input
                          name='name'
                          type="text"
                          value={formEmployee.name}
                          style={{fontSize: '1rem',width:'100%',padding:'2px 4px 2px 4px',}}
                          className="border rounded-md"
                      />
                      </div>
                      <div className='mb-2'>
                      <label
                          htmlFor="defined_id"
                          className="block text-left text-lg font-semibold text-gray-800"
                      >{t('CustomerAdd.Label.DefinedId')}</label>
                      <input
                          name='defined_id'
                          type="number"
                          value={formEmployee.defined_id}
                          style={{fontSize: '1rem',width:'100%',padding:'2px 4px 2px 4px',}}
                          className="border rounded-md"                  />
                      </div>
                      <div>
                      <label
                          htmlFor="department_id"
                          className="block text-left text-lg font-semibold text-gray-800"
                      >{t('Common.Department')}</label>
                      <select 
                      name='department_id'
                      value={formEmployee.department_id}
                      style={{fontSize: '1rem',width:'100%',height:'42px',padding:'4px 4px 4px 4px',}}
                       className="border rounded-md">
                        <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                        {(state.departments || []).map((department) => (
                          <option key={department.id} value={department.id}>{department.name}</option>
                        ))}
                      </select>
                      </div>
                  </div>
              </div>
              <div className="mt-6">
                  <div className="md:grid grid-cols-2 gap-4 mb-2">
                    <div className='mb-2'>
                      <label
                          htmlFor="date_of_entry"
                          className="block text-left text-lg font-semibold text-gray-800"
                      >{t('EmployeeList.Column.DateOfEntry')}</label>
                      <input
                          name='date_of_entry'
                          type="text"
                          value={formEmployee.date_of_entry ? DateTime.fromISO(formEmployee.date_of_entry).toFormat(dateFmt) : ""}
                          style={{fontSize: '1rem',width:'100%',padding:'2px 4px 2px 4px',}}
                          className="border rounded-md"
                      />
                      </div>
                      <div>
                      <label
                          htmlFor="date_of_departure"
                          className="block text-left text-lg font-semibold text-gray-800"
                      >{t('EmployeeList.Column.DateOfDeparture')}</label>
                      <input
                          name='date_of_departure'
                          type="text"
                          value={formEmployee.date_of_departure ? DateTime.fromISO(formEmployee.date_of_departure).toFormat(dateFmt) : ""}
                          style={{fontSize: '1rem',width:'100%',padding:'2px 4px 2px 4px',}}
                          className="border rounded-md"                  />
                      </div>
                  </div>
                  <div className="md:grid grid-cols-2 gap-4 mb-2">
                      <div>
                      <label
                          htmlFor="description"
                          className="block text-left text-lg font-semibold text-gray-800"
                      >{t('EmployeeAdd.Label.Description')}</label>
                      <input
                          name='description'
                          type="text"
                          readOnly value={formEmployee.description}
                          style={{fontSize: '1rem',width:'100%',padding:'2px 4px 2px 4px',}}
                          className="border rounded-md"
                      />
                      </div>
                  </div>
              </div>
              </div>);
            return buildCanonicalPrintHeaderHtml({
              branding: state?.branding,
              productFallbackSrc: defaultProductLogoSrc,
              companySettingsPrint: state?.company_settings_print,
              moduleSettings: state?.module_settings,
              title: t('Print.Title.TrainingRecordDetail'),
              printDateLabel: t('Print.DateLabel'),
              bodyHtml,
            });
        },
        printFooter: function () {
            return buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print });
        },     
      }}/>
    </SplitterPanel>
    </Splitter> 
    <Dialog header={t('TrainingRecordDetail.Text.Upravit_zaznam_skolenia')} visible={visibleRecord} style={{ width: '40vw' }} onHide={() => hideEditRecord()}>
            <form onSubmit={formikUpdate.handleSubmit}>
                    <div>
                        <label
                            htmlFor="training_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                        {t('Common.TrainingName')}
                        </label>
                        <select
                        name='training_id'
                        disabled value={formikUpdate.values?.training_id}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="">{t('Ui.R67.Vyber_skolenie')}</option>
                        {trainingTypesList.map(training => (
                            <option key={training.id} value={training.id}>{training.name}</option>
                        ))}
                        </select>
                    </div>   
                    <div>
                        <label
                            htmlFor="last_training_date"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Datum_skolenia')}</label>
                        <input
                            name='last_training_date'
                            type="date"
                            required
                            onChange={formikUpdate.handleChange} value={formikUpdate.values?.last_training_date}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                    </div>
                    <div>
                    <label
                        htmlFor="description"
                        className="block text-md font-semibold text-gray-800"
                    >{t('Common.NoteUpper')}</label>
                    <input
                        name='description'
                        type="text"
                        onChange={formikUpdate.handleChange} value={formikUpdate.values?.description}
                        className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                    </div>
                    <div>
                        <label
                            htmlFor="company_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.TrainingCompanyShort')}</label>
                        <select required
                        name='company_id'
                        onChange={(e) => changeCompany(e.target.value)} value={formikUpdate.values?.company_id}
                        disabled={loadingCompanies}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="">{loadingCompanies ? t('Common.LoadingEllipsis') : t('Common.SelectTrainingCompany')}</option>
                        {trainingCompanies.map((training_company) => (
                            <option key={training_company.id} value={training_company.id}>{training_company.name}</option>
                        ))}
                        </select>
                    </div> 
                    {(formikUpdate.values?.company_id!="" && formikUpdate.values?.company_id!=null) && <><div>
                        <label
                            htmlFor="machines"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Stroj*
                        </label>
                        <MultiSelect value={formikUpdate.values.machines} onChange={(e) => changeMachine(e.value)}
                            options={machines.map((machine) => 
                                ({name:machine.name,id:machine.id})
                            )} 
                            optionLabel="name"
                            dataKey="id"
                            filter placeholder={t('Common.SelectMachines')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        {formikUpdate.errors?.machines ? <span style={{color: "red"}}>{formikUpdate.errors?.machines}</span> : ""} 
                    </div>
                    {(formikUpdate.values?.machines?.length > 0) && <><div>
                        <label
                            htmlFor="lecturer_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                        Lektor
                        </label>
                        <select required
                        name='lecturer_id'
                        onChange={(e) => changeLecturer(e.target.value)} value={formikUpdate.values?.lecturer_id}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="">{t('Ui.R67.Vyber_lektora')}</option>
                        {lecturers.map((lecturer) => (
                            <option key={lecturer.id} value={lecturer.id}>{lecturer.name}</option>
                        ))}
                        </select>
                    </div>
                    {(formikUpdate.values?.lecturer_id!="" && formikUpdate.values?.lecturer_id!=null) && <div>
                        <label
                            htmlFor="company_contact_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Trainer')}</label>
                        <select
                        name='company_contact_id'
                        onChange={formikUpdate.handleChange} value={formikUpdate.values?.company_contact_id}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="">{t('Ui.R67.Vyber_skolitela')}</option>
                        {companyContacts.map((contact) => (
                            <option key={contact.id} value={contact.id}>{contact?.employee?.name || contact?.name}</option>
                        ))}
                        </select>
                    </div>}</>}</>}
                    <div>
                        <label
                            htmlFor="gauge_category"
                            className="block text-md font-semibold text-gray-800"
                        >
                            PROTOKOL
                        </label>
                        <input
                            name='files' 
                            ref={updateFileListRef}
                            onChange={handleUpdateFileChange}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                            type='file'
                            multiple="multiple"
                            id='file'/>
                    </div> 
                    {images!=='' && images.map((img) => ( <div className='flex flex-row p-2'>
                        <div onClick={() => setVisibleFiles(true)}>
                            <embed src={img.url+'#view=FitH&scrollbar=0'} width='100px' height='65px'></embed>
                        </div>
                            <div className='flex flex-col ml-4'>
                            <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => {setVisibleFiles(true);setViewedImage(img)}}>{img.filename}</a>
                            <button type="button" className='w-fit flex flex-row px-2 py-1 border rounded-md bg-red-900' onClick={() => {setViewedImage(img);deleteFiles(img)}} ><DeleteIcon/><span className='text-white ml-1'>{t('Common.Clear')}</span></button>
                            </div>
                        </div>))}
                    <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
                </form>
            </Dialog>
      <Dialog header={t('Common.PdfPreview')} visible={visibleFiles} onHide={() => setVisibleFiles(false)} style={{ width: '80vw',height:'90vh',backgroundColor: 'transparent',boxShadow: 'none'}}>
        <iframe src={viewedImage.url} className='w-full h-full'></iframe>
        </Dialog>
            <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index<1) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                          
                        {/* Use the React icon component */} 
                    </div> 
                })} 
            <button onClick={() => {setUserMaskFilter("TrainingRecordDetail","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
      
        </>
        )}
            </div>
            </> 
            );
} 
